// ID → локальный импорт картинки. Если файла нет — сборка подскажет.
import _4610094690368 from '../assets/products/4610094690368.webp'; // True baby-face serum
import _4610094691112 from '../assets/products/4610094691112.webp'; // C-Energy
import _4610094695615 from '../assets/products/4610094695615.webp'; // NMF-protection
import _4610094695998 from '../assets/products/4610094695998.webp'; // Brightening Skin
import _4610094696537 from '../assets/products/4610094696537.webp'; // Гель Retiderm 1.0
import _4670014508371 from '../assets/products/4670014508371.webp'; // Probioskin
import _4670014508593 from '../assets/products/4670014508593.webp'; // «Миорелакс»
import _4670014508944 from '../assets/products/4670014508944.webp'; // Retiderm 0,5
import _4670014509293 from '../assets/products/4670014509293.webp'; // Альфадерм
import _4670014509644 from '../assets/products/4670014509644.webp'; // 5 peptides
import _4680614170489 from '../assets/products/4680614170489.webp'; // Стик SPF50+
import _4680614170670 from '../assets/products/4680614170670.webp'; // Флюид SPF50+

export const productImages: Record<string, string> = {
  '4610094690368': _4610094690368,
  '4610094691112': _4610094691112,
  '4610094695615': _4610094695615,
  '4610094695998': _4610094695998,
  '4610094696537': _4610094696537,
  '4670014508371': _4670014508371,
  '4670014508593': _4670014508593,
  '4670014508944': _4670014508944,
  '4670014509293': _4670014509293,
  '4670014509644': _4670014509644,
  '4680614170489': _4680614170489,
  '4680614170670': _4680614170670,
};
